import Symbol from "./Symbol";
import { INSPECTOR_ELECTRONIC_RELAY, INSPECTOR_PROTECTION_RELAY } from "../../../constants/inspectorConstants";

// Relevador Electrónicos y electromecánicos
class ElectronicRelay extends Symbol {
    constructor({ alias, svgSrc, label, rotable, handles, name}) {
        super("ElectronicRelay", { alias, svgSrc, label, rotable, handles, name });

        if (label === 'Relevador de protección') {
            this.attributes = {
                ...this.attributes,
                brand: { isVisible: false, value: null, label: "Marca" },
                model: { isVisible: false, value: null, label: "Modelo" },
                ratedVoltage: { isVisible: false, value: null, label: "Voltaje nominal" },
                ratedCurrent: { isVisible: false, value: null, label: "Corriente nominal" },
                interruptingCapacity: { isVisible: false, value: null, label: "Capacidad interruptiva" },
                currentTransformerRatio: { isVisible: false, value: null, label: "Relación de transformadores de corriente (ej. 50/5, 250/5)" },
                tcPrimary: { isVisible: false, value: null, label: "TC Primario (TCP:)" },
                tcSecondary: { isVisible: false, value: null, label: "TC Secundario (TCS:)" },
                ltpu: { isVisible: false, value: null, label: "Pickup de tiempo largo (LTPU)" },
                curveType: { isVisible: false, value: null, label: "Tipo de curva" },
                timeDelay: { isVisible: false, value: null, label: "Retardo de tiempo" },
                shortTimePickup: { isVisible: false, value: null, label: "Pickup de tiempo corto" },
                definiteTime: { isVisible: false, value: null, label: "Tiempo definido" },
                instantaneous: { isVisible: false, value: null, label: "Instantáneo" },
                phaseLongTimePickup: { isVisible: false, value: null, label: "Pickup de tiempo largo" },
                phaseCurveType: { isVisible: false, value: null, label: "Tipo de curva" },
                phaseTimeDelay: { isVisible: false, value: null, label: "Retardo de tiempo" },
                phaseShortTimePickup: { isVisible: false, value: null, label: "Pickup de tiempo corto" },
                phaseDefiniteTime: { isVisible: false, value: null, label: "Tiempo definido" },
                phaseInstantaneous: { isVisible: false, value: null, label: "Instantáneo" },
                groundLongTimePickup: { isVisible: false, value: null, label: "Pickup de tiempo largo" },
                groundCurveType: { isVisible: false, value: null, label: "Tipo de curva" },
                groundTimeDelay: { isVisible: false, value: null, label: "Retardo de tiempo" },
                groundShortTimePickup: { isVisible: false, value: null, label: "Pickup de tiempo corto" },
                groundDefiniteTime: { isVisible: false, value: null, label: "Tiempo definido" },
                groundInstantaneous: { isVisible: false, value: null, label: "Instantáneo" },
                otherProtections: { isVisible: false, value: null, label: "Otras protecciones" },
            };
        } else {
            this.attributes = {
                ...this.attributes,
                fabricante: { isVisible: false, value: null, label: "Fabricante" },
                modelo: { isVisible: false, value: null, label: "Modelo" },
                tcs: { isVisible: false, value: null, label: "TCs" },
                ajustes_corriente_tiempo_largo: { isVisible: false, value: null, label: "Ajustes - Corriente de tiempo largo" },
                ajustes_tipo_de_curva: { isVisible: false, value: null, label: "Ajustes - Tipo de curva" },
                ajustes_tiempo_de_retardo: { isVisible: false, value: null, label: "Ajustes - Tiempo de retardo" },
                ajustes_corriente_instantanea: { isVisible: false, value: null, label: "Ajustes - Corriente instantánea" },
                ajustes_retardo_instantaneo: { isVisible: false, value: null, label: "Ajustes - Retardo instantáneo" },
            };
        }
    }

    getInspector() {
        if (this.label === 'Relevador de protección') {
            return INSPECTOR_PROTECTION_RELAY;
        }
        return INSPECTOR_ELECTRONIC_RELAY;
    }
}

export default ElectronicRelay;
